import styled from 'styled-components';


/*
========================================
CONTENEDOR
========================================
*/

export const ContenedorGestionMetodo =
    styled.div`

    width:
        94%;

    max-width:
        850px;

    box-sizing:
        border-box;

    margin:
        2rem
        auto
        3rem
        auto;
`;


/*
========================================
TARJETA
========================================
*/

export const TarjetaGestionMetodo =
    styled.div`

    width:
        100%;

    box-sizing:
        border-box;

    padding:
        1.8rem
        2rem;

    border:
        1.5px solid
        #69BEB8;

    border-radius:
        22px;

    background-color:
        #FFFFFF;


    @media (max-width: 650px) {

        padding:
            1.3rem
            1.1rem;
    }
`;


/*
========================================
ENCABEZADO
========================================
*/

export const EncabezadoGestionMetodo =
    styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        space-between;

    gap:
        1rem;

    flex-wrap:
        wrap;

    margin-bottom:
        1.2rem;
`;


export const TituloGestionMetodo =
    styled.h2`

    margin:
        0;

    font-size:
        1.15rem;

    font-weight:
        800;

    color:
        #23AAAF;
`;


/*
========================================
ESTADO
========================================
*/

export const EstadoGestionMetodo =
    styled.div`

    display:
        inline-flex;

    align-items:
        center;

    padding:
        0.4rem
        0.8rem;

    border-radius:
        18px;

    font-size:
        0.74rem;

    font-weight:
        800;

    background-color:
        ${
            props => {

                if (
                    props.$estado ===
                    'activo'
                ) {

                    return '#EDF9F4';

                }


                if (
                    props.$estado ===
                    'apto'
                ) {

                    return '#F7F6FE';

                }


                return '#FFF4E8';

            }
        };

    color:
        ${
            props => {

                if (
                    props.$estado ===
                    'activo'
                ) {

                    return '#17856B';

                }


                if (
                    props.$estado ===
                    'apto'
                ) {

                    return '#514BBE';

                }


                return '#C96F1B';

            }
        };
`;


/*
========================================
TEXTO
========================================
*/

export const TextoGestionMetodo =
    styled.p`

    margin:
        0
        0
        1.3rem
        0;

    font-size:
        0.86rem;

    line-height:
        1.55;

    color:
        #646464;
`;


/*
========================================
CUPOS
========================================
*/

export const ResumenCupos =
    styled.div`

    display:
        grid;

    grid-template-columns:
        repeat(
            3,
            minmax(
                0,
                1fr
            )
        );

    gap:
        0.8rem;

    margin:
        1.2rem
        0;
        

    @media (max-width: 600px) {

        grid-template-columns:
            1fr;
    }
`;


export const DatoCupo =
    styled.div`

    box-sizing:
        border-box;

    padding:
        0.9rem;

    border:
        1px solid
        #B8DEDC;

    border-radius:
        12px;

    background-color:
        #F3FAFA;

    text-align:
        center;

    font-size:
        0.76rem;

    font-weight:
        700;

    color:
        #646464;
`;


export const ValorCupo =
    styled.div`

    margin-top:
        0.25rem;

    font-size:
        1.25rem;

    font-weight:
        800;

    color:
        #23AAAF;
`;


/*
========================================
AVISOS
========================================
*/

export const AvisoGestionMetodo =
    styled.div`

    box-sizing:
        border-box;

    margin:
        1rem
        0;

    padding:
        0.9rem
        1rem;

    border-left:
        4px solid
        ${
            props =>
                props.$advertencia
                    ?
                    '#E7973C'
                    :
                    '#655EE8'
        };

    border-radius:
        9px;

    background-color:
        ${
            props =>
                props.$advertencia
                    ?
                    '#FFF4E8'
                    :
                    '#F7F6FE'
        };

    font-size:
        0.8rem;

    line-height:
        1.5;

    color:
        ${
            props =>
                props.$advertencia
                    ?
                    '#C96F1B'
                    :
                    '#514BBE'
        };


    strong {

        font-weight:
            800;
    }
`;


/*
========================================
ACCIONES
========================================
*/

export const AccionesGestionMetodo =
    styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        flex-end;

    gap:
        0.7rem;

    margin-top:
        1.4rem;
`;


/*
========================================
ACTIVAR
========================================
*/

export const BotonActivarMetodo =
    styled.button`

    min-height:
        40px;

    box-sizing:
        border-box;

    padding:
        0.6rem
        1.2rem;

    border:
        none;

    border-radius:
        9px;

    background-color:
        #FC8906;

    color:
        #FFFFFF;

    font-family:
        inherit;

    font-size:
        0.8rem;

    font-weight:
        800;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        opacity:
            0.9;
    }


    &:disabled {

        background-color:
            #D8D8D4;

        color:
            #777777;

        cursor:
            not-allowed;
    }
`;


/*
========================================
DAR DE BAJA
========================================
*/

export const BotonDarBajaMetodo =
    styled.button`

    min-height:
        40px;

    box-sizing:
        border-box;

    padding:
        0.6rem
        1.2rem;

    border:
        1.5px solid
        #D76970;

    border-radius:
        9px;

    background-color:
        #FFFFFF;

    color:
        #D76970;

    font-family:
        inherit;

    font-size:
        0.8rem;

    font-weight:
        800;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        background-color:
            #FFF5F5;
    }


    &:disabled {

        opacity:
            0.5;

        cursor:
            not-allowed;
    }
`;


/*
========================================
SIN PACIENTE
========================================
*/

export const TextoSinPaciente =
    styled.div`

    font-size:
        0.84rem;

    color:
        #646464;
`;